<script setup lang="ts">
import Generic from '~/layouts/generic.vue'
import Header from '~/components/Layout/Header.vue'
import LazyNewsletterDialog from '~/components/Newsletter/NewsletterDialog.vue';

const { setCategory } = useCategoryStore()

useAsyncData('category', async () => setCategory(), { server: false })
</script>

<template>
  <Generic>
    <a href="#main-content"
      class="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[9999] focus:px-4 focus:py-3 focus:bg-primary focus:text-white focus:font-bold focus:rounded-lg focus:shadow-lg">
      Vai al contenuto principale
    </a>
    <Header alternative />
    <LazyNewsletterDialog />
    <Toast position="bottom-center" group="bl" />
    <main id="main-content" tabindex="-1" class="mt-20 w-full bg-white">
      <router-view />
    </main>
  </Generic>
</template>
